
/**
 * Searches dom starting from current focused element for the next focusable element in targets array

 * @param targets - array of focusable elements
 * @param reverse - search backwards through targets array
 * @returns *Matching element is focused then returned
 */
export function focusNextTarget(targets: HTMLElement[], reverse: boolean): HTMLElement {
	const active = document.activeElement as HTMLElement;
	const next = findNextElement(active, targets, reverse);
	next?.focus();
	return next;
}

// focus on the next or previous element in the menu. Loops around to beginning when the end is reached.
function findNextElement(active: HTMLElement, targets: HTMLElement[], isReverse: boolean): HTMLElement {
	let nodePosition: any = Node.DOCUMENT_POSITION_FOLLOWING;
	if(!targets.length) {
		return;
	}

	let searchNodes = targets;
	if(isReverse) {
		searchNodes = targets.reverse();
		nodePosition = Node.DOCUMENT_POSITION_PRECEDING;
	}

	return searchNodes.find(el => active.compareDocumentPosition(el) & nodePosition)
		|| searchNodes[0];
}
